import styled from 'styled-components';

export const FormStyled = styled.form`
  display: grid;
  grid-template-columns: 35% 35% 30%;
  height: calc(100% - 91px);
`;
